<template>
  <a-layout :class="['layout', device]">
    <!-- SideMenu -->
    <a-drawer
      v-if="isMobile()"
      placement="left"
      :wrapClassName="`drawer-sider ${navTheme}`"
      :closable="false"
      :visible="collapsed"
      @close="drawerClose"
    >
      <ak-side-menu
        mode="inline"
        :theme="navTheme"
        :collapsed="false"
        :collapsible="true"
        @menuSelect="menuSelect"
      >
        <logo/>
      </ak-side-menu>
    </a-drawer>

    <ak-side-menu
      v-else-if="isSideMenu"
      mode="inline"
      :theme="navTheme"
      :collapsed="collapsed"
      :collapsible="true"
    >
      <logo/>
    </ak-side-menu>

    <a-layout :class="[layoutMode, `content-width-${contentWidth}`]" :style="{ paddingLeft: contentPaddingLeft, minHeight: '100vh' }">
      <!-- layout header -->
      <global-header
        :fixedHeader="fixedHeader"
        :mode="layoutMode"
        :theme="navTheme"
        :collapsed="collapsed"
        :device="device"
        @toggle="toggle"
      />

      <!-- layout content -->
      <a-layout-content :style="{ height: '100%', margin: '24px 24px 0', paddingTop: fixedHeader ? '64px' : '0' }">
        <transition name="page-transition">
          <router-view />
        </transition>
      </a-layout-content>
      <!-- layout footer -->
      <a-layout-footer>
        <global-footer />
      </a-layout-footer>
    </a-layout>
  </a-layout>

</template>

<script>
import { mapState } from 'vuex'
import GlobalHeader from '@/components/GlobalHeader'
import GlobalFooter from '@/components/GlobalFooter'
import config from '@/config'
import Logo from '@/components/tools/Logo'

export default {
  name: 'DefaultLayout',
  components: {
    GlobalHeader,
    GlobalFooter,
    Logo
  },
  data () {
    return {
      collapsed: false,
      layoutMode: config.layoutMode,
      contentWidth: config.contentWidth,
      fixedHeader: config.fixedHeader,
      fixSidebar: config.fixSidebar,
      navTheme: config.navTheme
    }
  },
  computed: {
    ...mapState([
      'sidebarOpened'
    ]),
    isSideMenu () {
      return this.layoutMode === 'sidemenu'
    },
    contentPaddingLeft () {
      if (!this.fixSidebar || this.isMobile()) {
        return '0'
      }
      if (this.sidebarOpened) {
        return '256px'
      }
      return '80px'
    }
  },
  watch: {
    sidebarOpened (val) {
      this.collapsed = !val
    }
  },
  methods: {
    setSidebar (sidebarOpened) {
      this.$store.commit('setSidebarOpened', sidebarOpened)
    },
    toggle () {
      this.collapsed = !this.collapsed
      this.setSidebar(!this.collapsed)
      this.triggerWindowResizeEvent()
    },
    menuSelect () {
      if (!this.isDesktop()) {
        this.collapsed = false
      }
    },
    drawerClose () {
      this.collapsed = false
    }
  }
}
</script>

<style lang="scss">
  .page-transition-enter {
    opacity: 0;
  }

  .page-transition-leave-active {
    opacity: 0;
  }

  .page-transition-enter .page-transition-container,
  .page-transition-leave-active .page-transition-container {
    transform: scale(1.1);
  }
</style>
